/**
 * Cart Vue Mixin
 * ------------------------------------------------------------------------------
 * Cart functionality
 *
 * Mixin is shared with:
 * - app.js
 */

export const cart = {
  props: {
  },
  data: {
    isCartLoading: false,
    cart: null,
    membershipDiscount: 1
  },

  created () {
  },

  computed: {

    finalCartPrice () {
      /* eslint-disable camelcase */
      return this.cart?.items ? this.cart?.items.reduce((a, { final_line_price }) => a + final_line_price, 0) : null
    },

    customerTier () {
      return null
    }

  },

  methods: {
    updateQuantity (item, quantity) {
    },

    addToCart (sku, handle, quantity = 1, properties) {
    },

    async _getCart () {
    },

    minusQuantity (item) {
      let bottleQuantity = item.tags.find(tag => tag.toLowerCase().includes('bottles_per_case|'))

      bottleQuantity = bottleQuantity ? parseInt(bottleQuantity.split('|').pop()) : 1
      item.quantity = item.quantity > bottleQuantity ? item.quantity - bottleQuantity : 0
    },

    addQuantity (item) {
      let bottleQuantity = item.tags.find(tag => tag.toLowerCase().includes('bottles_per_case|'))

      bottleQuantity = bottleQuantity ? parseInt(bottleQuantity.split('|').pop()) : 1
      item.quantity = item.quantity + bottleQuantity
    }
  }
}
